export default __webpack_public_path__ + "static/media/mark-attendance-disabled.7a790b42.svg";